module.exports = __webpack_public_path__ + "static/assets/44175bf97f10ff4dcddf5c5b5e66b41d.png";